export enum IpConfigurationParameterKeys {
    ENABLE_ACTIVE_CURRENCY_CONVERSIONS_TAB = 'ENABLE_ACTIVE_CURRENCY_CONVERSIONS_TAB',
    ENABLE_CONFIGURATION_PARAMETERS_TAB = 'ENABLE_CONFIGURATION_PARAMETERS_TAB',
    ENABLE_PERIOD_CURRENCY_CONVERSIONS_TAB = 'ENABLE_PERIOD_CURRENCY_CONVERSIONS_TAB',
    VALIDATE_CURRENCY_CONVERSIONS_FOR_SETTLEMENT_FROM_SALES = 'VALIDATE_CURRENCY_CONVERSIONS_FOR_SETTLEMENT_FROM_SALES',
    HOLDBACK_CURRENCY_TYPE = 'HOLDBACK_CURRENCY_TYPE',
    INVOICE_EXTRA_FILE_REQUIRED = 'INVOICE_EXTRA_FILE_REQUIRED',
    SETTLEMENT_EMAIL_NOT_ALLOWED = 'SETTLEMENT_EMAIL_NOT_ALLOWED',
    SETTLEMENT_TABLE_FILTER_FIELDS = 'SETTLEMENT_TABLE_FILTER_FIELDS',
    ENABLE_EDIT_SETTLEMENTS_SALES = 'ENABLE_EDIT_SETTLEMENTS_SALES',
    ENABLE_ENTERPRISE_INVOICE_CREATION = 'ENABLE_ENTERPRISE_INVOICE_CREATION',
    SETTLEMENT_TOTAL_CALCULATE_BTN = 'SETTLEMENT_TOTAL_CALCULATE_BTN',
    ENABLE_HOLDBACK_PREDETERMINATED_CHECK = 'ENABLE_HOLDBACK_PREDETERMINATED_CHECK',
    SETTLEMENT_SALE_TABLE_FILTER_FIELDS = 'SETTLEMENT_SALE_TABLE_FILTER_FIELDS',
    ENABLE_CURRENCY_FOR_INVOICE = 'ENABLE_CURRENCY_FOR_INVOICE',
    ENABLE_INVOICE_REPORTING = 'ENABLE_INVOICE_REPORTING',
    ENABLE_SETTLEMENT_REPORTING = 'ENABLE_SETTLEMENT_REPORTING',
    DATE_FORMAT = 'DATE_FORMAT',
    DATE_TIME_FORMAT = 'DATE_TIME_FORMAT',
    DATE_TIME_FIELDS = 'DATE_TIME_FIELDS',
    BROKER_PAYMENTS_DASHBOARD_HIDDEN = 'BROKER_PAYMENTS_DASHBOARD_HIDDEN',
    COMPONENTS_DASHBOARD_VISIBILITY = 'COMPONENTS_DASHBOARD_VISIBILITY',
    WITHOUT_DASHBOARD_BROKER = 'WITHOUT_DASHBOARD_BROKER',
    ENABLE_SALES_POLICY_INFO = 'ENABLE_SALES_POLICY_INFO',
    CONTACT_NOTIFICATIONS_TYPES = 'CONTACT_NOTIFICATIONS_TYPES',
    ENTERPRISE_BANK_ACCOUNT_USD = 'ENTERPRISE_BANK_ACCOUNT_USD',
    ENTERPRISE_BANK_ACCOUNT_PEN = 'ENTERPRISE_BANK_ACCOUNT_PEN',
}